export function getDomain() {
  return window.location.origin
}
